/**
 * Export an Axios instance
 * configured for the Minimart API.
 */

import { MM_API_BASE_URL } from '../constants/credentials'
import axios from 'axios'
import _get from 'lodash/get'
import CreateMock from '@/tests/mocks/LaravelMockAdapter'

// eslint-disable-next-line new-cap
const Laravel = new axios.create({
  baseURL: MM_API_BASE_URL,
  timeout: 6000,
  headers: {
    Accept: 'application/json',
  },
})

Laravel.interceptors.request.use(
  (config) => {
    const vuex =
      typeof localStorage !== 'undefined'
        ? JSON.parse(localStorage.getItem('vuex'))
        : {}
    const token = _get(vuex, 'admin.token', null)

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
  },

  (error) => {
    return Promise.reject(error)
  }
)

Laravel.interceptors.response.use(
  function(response) {
    // Do something with response data
    // console.log('Intercepted api response', { response })
    return response
  },
  function(error) {
    // Do something with response error
    // console.log({ error })
    if (error.response && error.response.status === 401) {
      // console.log('🏃‍♂️ LOGOUT')
      // store.dispatch('auth/logout')
      // store.dispatch('auth/showAuthModal')
      // store.dispatch('auth/showAuthSnackbar')
    } else if (error.response && error.response.status === 404) {
      return Promise.reject(error)
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      // console.log(error.request)
      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

let USE_MOCK = true
USE_MOCK = false

if (USE_MOCK) {
  CreateMock(Laravel)
}

export default Laravel
